export const getEnvConfig = () => window.ENV_CONFIG;

export const createDocsUrl = (path: string) => `${getEnvConfig().docsUrl}${path}`;
